export default __webpack_public_path__ + "static/media/jp.4ecbd30a.svg";